import { ReactComponent as Setting } from "../../assets/icons/settings.svg";
import DoctorSettingPopup from "../../pages/Admin/Users/Popup/DoctorSettingPopup";
import logoutImg from "../../assets/icons/logoutimg.png";

const HeaderText = ({ title, type, popupOpen, setPopupOpen }) => {
  const onClose = () => {
    setPopupOpen(false);
  };

  const openEMRPage = () => {
    const width = 580;
    const height = 600;
    const left = window.innerWidth / 2 - width / 2;
    const top = window.innerHeight / 2 - height / 2;
    const options = `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`;

    const emrPageURL = `/EMRRegister`;

    window.open(emrPageURL, "EMR 등록", options);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("userid");
    localStorage.removeItem("id");
    localStorage.removeItem("active");
    window.location.reload();
  };

  return (
    <div className="header-text-container">
      <div className="react-header-text">{title ? title : "스마트닥"}</div>
      {type !== "admin" && (
        <>
          <div className="emr-button">
            <button className="emr-button" onClick={openEMRPage}>
              EMR 등록
            </button>
          </div>
          <img src={logoutImg} alt="로그아웃" className="logout-button" style={{ marginLeft: "5px" }} onClick={handleLogout} />
        </>
      )}

      <div className="setting-button" onClick={() => setPopupOpen(true)}>
        <Setting fill="#ffffff" width={18} />
      </div>
      <DoctorSettingPopup isOpen={popupOpen} setIsOpen={setPopupOpen} onClose={onClose} />
    </div>
  );
};

export default HeaderText;
